import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import { api } from './api/index.js'
import base from './common/base.js'
import { commonApi } from './common/cpmmonApi'
// import vConsole from './common/vconsole'
import MintUI from 'mint-ui'
import wx from 'weixin-js-sdk'
import 'mint-ui/lib/style.css'
Vue.prototype.$api = api
Vue.prototype.$commonApi = commonApi
Vue.prototype.$base = base;
Vue.config.productionTip = false
Vue.use(MintUI)
Vue.prototype.$dict = window.dict
var newProject = base.getStorage('newProject')
if (newProject != 1) {
    var storage = window.localStorage;
    storage.clear()
    base.setStorage('newProject', 1)
}
if (base.getStorage("isSNS")) {
    base.removeStorage("isSNS");
}
if (base.getStorage('continueReading')) {
    base.removeStorage("continueReading");
}
if (base.getStorage('muchCompontent1')) {
    base.removeStorage("muchCompontent1");
}
if (base.getStorage('BannerList1')) {
    base.removeStorage("BannerList1");
}
if (base.getStorage('muchCompontent0')) {
    base.removeStorage("muchCompontent0");
}
if (base.getStorage('BannerList0')) {
    base.removeStorage("BannerList0");
}



Vue.directive('myfocus', {
    inserted: (el, binding) => {
        if (binding.value == true || binding.value == undefined) {
            el.focus()
        }
    }
});
router.beforeEach((to, from, next) => {
    console.log(from)
    console.log('111')
    var openId = base.getStorage("openid");
    var isConnect = base.localStorageGet('isConnect');
    if (!openId) { // 判断该路由是否需要登录权限
        if(to.path=='/pages/index/index'){
            next();
        }else{
            getOpenId(isConnect,next);
        }
    } else {
        if(isConnect!=1){
            isSilentLogin(openId)
        }
       
        next();
    }
 
});
router.afterEach((to,from) => {
    console.log('222')
    var currentPage=to.name;
    var messageType= to.query.messageType,
    clickMessId=to.query.clickMessId,
    channelRecordId=to.query.channelRecordId,
    promotionCode=to.query.promotionCode;

    if (messageType ||channelRecordId || promotionCode||clickMessId) {
        commonApi.insertClickReporting(messageType,clickMessId,channelRecordId,promotionCode);
        }
  })
function getOpenId(isConnect,next) {
    var code = base.GetUrlParam("code");
    if (!code) {
        let uri = encodeURIComponent(window.location.href);
        window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            store.state.user.appid +
            "&redirect_uri=" +
            uri +
            "&response_type=code&scope=snsapi_base&state=state&wechat_redirect&connect_redirect=1#wechat_redirect";
    } else {
        var params = {
            code: code,
        };
        api.userRegister(params).then((res) => {
            if (res.status == 1) {
                base.setStorage("openid", res.data.openid);
                if(isConnect!=1){
                    isSilentLogin(res.data.openid)
                }else{
                    if (res.data.isNewUser == 1) {
                        //如果是新用户跳转到选择频类的页面
                        router.push({
                          path: "/pages/bookFrency/index",
                          query: { pageType: "" },
                        });
                      }
                }
                base.setStorage('frequency', res.data.frequency)
                var id = base.getStorage("uid");
                if (!id) {
                    commonApi.getUserInfo(res.data.openid);
                }
                next();
            }
        });
    }
}
function isSilentLogin(openid) { // 上面的请求也可以这样做
    axios.get(commonApi.PayURL()+'/api/SyncOfficial/isSilentLogin', {
        params: {
            openid: openid
        }
    }).then(function (res) {
        if (res.data.status == 1) {
            if (res.data.data) {//"获取是否在中台公众号静默授权登录过" true没有关联 false已关联
                window.location.href = commonApi.JumpURL()+'contentIndex.html?originOpenid='+openid+'&url='+(window.location.origin +'/'+window.location.hash )
            }else{
                base.localStorageSet('isConnect', 1, 24)
            }
        }
    }).catch(function (error) {
    });
}



/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js